const userActionList = {
  updateUsers: 'userList/update',
  updateUser: 'user/update'
};

export default userActionList;
